import { Dispatch } from 'react';
import { toast } from 'react-toastify';
import { ActionTypes } from './types';
import { ICredencialFormValues } from '../../../components/Forms/Pages/CadastrarCredencialModal/types';
import { IFilterBusinessProps, BusinessDto, IBusinessInfo } from '../../../global/dataTransferObjects/credencial';
import { IPagedResult } from '../../../global/generics';
import createCredencialService from '../../../services/credencial';
import { HttpStatus } from '../../../services/providers/types';

export const onUpdateLoadingStatus = (status = false) => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.UPDATE_LOADING_STATUS,
  payload: {
    status,
  },
});

export const onGetAllBusiness = (business: IPagedResult<BusinessDto>) => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.GET_ALL_BUSINESS,
  payload: {
    business: { ...business },
  },
});

export const onOpenCredentialModal = () => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.OPEN_CREDENTIAL_MODAL,
});

export const onUpdateBusinessModalStatus = (status = false) => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.OPEN_BUSINESS_MODAL,
  payload: { status },
});

export const onUpdateCredentialModalStatus = (status = false) => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.UPDATE_CREDENTIAL_MODAL_STATUS,
  payload: { status },
});

export const onUpdateBusiness = (
  business: IBusinessInfo,
) => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.UPDATE_BUSINESS_MODAL,
  payload: {
    businessInfo: { ...business },
  },
});

export const openBusinessViewModal = (
  business: IBusinessInfo,
) => (dispatch: Dispatch<any>): void => {
  onUpdateBusiness({ ...business })(dispatch);
  onUpdateBusinessModalStatus(true)(dispatch);
}

export const onCreateNewCredential = () => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.CREATE_NEW_CREDENTIAL,
});

export const createNewCredencial = (values: ICredencialFormValues) => async (dispatch: Dispatch<any>): Promise<boolean> => {
  const credencialService = createCredencialService();

  onUpdateLoadingStatus(true)(dispatch);
  const payload = { ...values };
  const result = await credencialService.createNewCredential(payload);

  if (result.status !== HttpStatus.CREATED) {
    toast.error(result.message ?? 'Houve um erro ao cadastrar a credencial');
    return false;
  }
  onCreateNewCredential()(dispatch);
  return true;
};

export const getAllBusiness = (
  offSet: number,
  pageSize: number,
  filter?: IFilterBusinessProps,
) => async (dispatch: Dispatch<any>): Promise<void> => {
  const userService = createCredencialService();
  onUpdateLoadingStatus(true)(dispatch);

  const result = await userService.getAllBusiness(offSet, pageSize, filter);
  if (result.status !== 200) {
    toast.error(result.message);
    return;
  }

  onGetAllBusiness(result.response)(dispatch);
};
